import React from 'react';
import styled from 'styled-components';
import SelectBox from './SelectBox';
import { SelectType, Language } from '../enum/EnumRepository';
import { useLanguageStore } from '../store/languageStore';


const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useLanguageStore();

  const getLanguageDisplay = (lang: Language): string => {
    switch (lang) {
      case Language.KR:
        return 'KOR';
      case Language.EN:
        return 'ENG';
      default:
        return lang;
    }
  };

  return (
    <LanguageSelectorComp>
      <SelectBoxWrapper>
        <SelectBox
          value={language}
          selectType={SelectType.LANGUAGE}
          handleChange={(value: Language) => setLanguage(value)}
          direction={true}
          getDisplayText={getLanguageDisplay}
        />
      </SelectBoxWrapper>
    </LanguageSelectorComp>
  );
};

export default LanguageSelector;

const LanguageSelectorComp = styled.section`
  width: fit-content;
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
`;

const SelectBoxWrapper = styled.div`
  width: clamp(35px, 3.5vw, 45px);
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Footer_01};
`;
